<template>
  <a-card :border="false">
    <a-result :status="resultCp.typeMap[privacyData.status]"
      :title="resultCp.typeMap[privacyData.status]"
      :sub-title="resultCp.subTitleMap[privacyData.status]">
      <template #extra>
        <a-button key="console" type="primary" v-has:privacyAgreement='seting'>
          {{resultCp.titleMap[privacyData.status]}}</a-button>
      </template>
    </a-result>

    <div v-if="privacyData.lackPrivacy.length">
      <a-alert v-for="(item, index) in privacyData.lackPrivacy" :key="index" :message="'缺少 ' + item.privacy_desc + '(' + item.privacy_key + ') 权限'" type="warning" show-icon />
    </div>
  </a-card>

</template>
<script>
  import { privacySetting, getPrivacy } from "@/api/appletCode";
  import { useRoute } from 'vue-router';
  import { $iscode } from '../../../../utils/app';
  import { onMounted, ref, reactive } from '@vue/runtime-core';
  export default {
    setup() {
      const $route = useRoute()
      const privacyDetail = ref({ owner_setting: {contact_phone: ""} })
      let statusMap = {
        empty: "未设置",
        reset: "重新设置",
        set: "已设置"
      }
      const privacyData = reactive({
        status: "", // 隐私设置
        statusText: "", // 隐私设置
        lackPrivacy: [],
      })
      const resultCp = {
        typeMap: {
          empty: "info",
          reset: "warning",
          set: "success"
        },
        titleMap: {
          empty: "未设置",
          reset: "重新设置",
          set: "已设置"
        },
        subTitleMap: {
          empty: "该小程序未设置隐私保护协议",
          reset: "该小程序需要重新设置隐私保护协议",
          set: "该小程序已设置隐私保护协议"
        },
      }
      const initData = async () => {
        let result = await getPrivacy({ brand_id: $route.query.brand_id, appid: $route.query.app_id,miniapp_type:$route.query.miniapp_type?$route.query.miniapp_type:""  }).then(res => res.data).catch(error => error)
        let respData = result.data || {}
        respData.owner_setting = respData.owner_setting || {}
        // contact_phone不存在就是没有设置
        if (!respData.owner_setting.contact_phone) {
          privacyData.status = "empty"
          privacyData.statusText = statusMap[privacyData.status]
          return
        }
        // 代码中需要的设置
        let hasPrivacy = respData.privacy_list || []
        // 我们已经申请的设置
        let appliedPrivacy = respData.setting_list || []
        // 腾讯的权限描述
        respData.privacy_desc = respData.privacy_desc || {}
        let allPrivacy = respData.privacy_desc.privacy_desc_list || []

        // 缺少权限
        let lackPrivacy = [];
        hasPrivacy.forEach(item => {
          let hasItem = appliedPrivacy.find(itemA => itemA.privacy_key == item )
          if (!hasItem) {
            let lackItem = lackPrivacy.find(item => item.privacy_key == item)
            if (lackItem) {
              lackPrivacy.push(lackItem)
            } else {
              lackPrivacy.push({
                privacy_key: item,
                privacy_desc: "未知权限",
              })
            }
          }
        })
        // 如果缺失权限，就是需要重置
        if (lackPrivacy.length) {
          privacyData.status = "reset"
          privacyData.lackPrivacy = lackPrivacy
          privacyData.statusText = statusMap[privacyData.status]
          return
        }

        privacyData.status = "set"
        privacyData.lackPrivacy = []
        privacyData.statusText = statusMap[privacyData.status]
        
        privacyDetail.value = result.data
      }
      const seting = async () => {
        let result = await privacySetting({ brand_id: $route.query.brand_id, appid: $route.query.app_id,miniapp_type:$route.query.miniapp_type?$route.query.miniapp_type:""  }).then(res => res.data).catch(error => error)
        $iscode(result, true)
        initData()
      }
      onMounted(() => {
        initData()
      })
      return {
        seting,
        privacyData,
        resultCp,
        privacyDetail
      }

    }
  };
</script>